import React, { useEffect, useState } from 'react';
import { Box, CssBaseline, Button } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import AppNavigation from './navigation';
import SubscriptionDashboard from './subsDash';
import AllAppsDashboard from './allApps';
import UsersDashboard from './usersDash';

const APP_LIST = [
  { id: "674997d8c4aaadc4054b3372", name: "Anesthesia Assistant" },
  { id: "5e98254f2d1ce10e9431f525", name: "Nerve Blocks" },
  { id: "609a8163ddb62a107efb6a5c", name: "US Pain" },
  { id: "60d19b028ac2e540ca51bbdc", name: "VetRA" },
  { id: "60ddae1f7ffdc227199348ce", name: "Interventional Pain" },
  { id: "610280ea01c6203e11f777ea", name: "MSK US Knee" },
  { id: "63a1becbe53caf5ce853f91f", name: "Pocus" },
  { id: "65a7e37abb2a9f5281b10bce", name: "IV Access" },
];

const AppAnalytics = ({handleLogout, viewMode, handleSelectMode}) => {
  const [loading, setLoading] = useState(true);

  const [selectedApp, setSelectedApp] = useState(() => {
    return localStorage.getItem(process.env.REACT_APP_STORAGE_SELECTED_APP) || APP_LIST[0].id;
  });

  const [showAllApps, setShowAllApps] = useState(() => {
    return localStorage.getItem(process.env.REACT_APP_STORAGE_SHOW_ALL_APPS) === 'true';
  });

  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    localStorage.setItem(process.env.REACT_APP_STORAGE_SELECTED_APP, selectedApp);
  }, [selectedApp]);

  useEffect(() => {
    localStorage.setItem(process.env.REACT_APP_STORAGE_SHOW_ALL_APPS, showAllApps);
  }, [showAllApps]);

  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: {
        main: process.env.REACT_APP_PRIMARY_COLOR || '#3f51b5',
      },
      secondary: {
        main: process.env.REACT_APP_SECONDARY_COLOR || '#f50057',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex' }}>
        {viewMode !== 'users' && (
          <AppNavigation 
            selectedApp={selectedApp} 
            setSelectedApp={setSelectedApp}
            showAllApps={showAllApps}
            setShowAllApps={setShowAllApps}
            APP_LIST={APP_LIST}
            handleLogout={handleLogout}
            setLoading={setLoading}
            loading={loading}
          />
        )}
        <Box
          component="main"
          sx={{ 
            flexGrow: 1, 
            minHeight: '100vh',
            bgcolor: 'background.default',
            overflow: 'auto'
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', p: 1 }}>
            <Button
              onClick={() => handleSelectMode('')}
              startIcon={<ArrowBack />}
              color="primary"
              variant="text"
              size="small"
            >
              Back to main menu
            </Button>
          </Box>
          {viewMode === 'users' ? (
            <UsersDashboard
              selectedApp={selectedApp}
              setLoading={setLoading}
              loading={loading}
            />
          ) : (
            <>
              {showAllApps ? (
                <AllAppsDashboard 
                APP_LIST={APP_LIST} 
                setLoading={setLoading} 
                loading={loading}/>
              ) : (
                <SubscriptionDashboard 
                selectedApp={selectedApp} 
                APP_LIST={APP_LIST} 
                setLoading={setLoading} 
                loading={loading}/>
              )}
            </>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default AppAnalytics;
